import apiClient from "../config/apiClient";

export const sendCateringPackage = async (restaurantId, sendData) => {
  try {
    const response = await apiClient.post(
      `/agent/catering-package/${restaurantId}/send`,
      sendData
    );
    return response.data;
  } catch (error) {
    console.error("Send catering package request failed:", error);
    throw error;
  }
}; 